var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 5,
    viewBox: "0 0 6 5",
    fill: "#9F9F9F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20759 1.02937C2.6079 0.509357 3.3921 0.509358 3.79241 1.02937L5.22473 2.89001C5.73092 3.54757 5.26216 4.5 4.43232 4.5H1.56768C0.737838 4.5 0.269076 3.54757 0.775273 2.89001L2.20759 1.02937Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.b592bab4a6b7e087ca165b4bbe6a9174.svg";
export { ForwardRef as ReactComponent };